import { c as _c } from "react/compiler-runtime";
import Chip from '@cc-shopping/ui/composites/Chip';
import { Stack } from '@mui/material';
import { startTransition, useCallback } from 'react';
import { useShallow } from 'zustand/shallow';
import { initialFilterState } from '../../store';
import { useOffersFilterStore } from '../../store/Context';
import type { FilterType } from '../../store/enums';
import { useFiltersAnalytics } from '../../store/hooks/useFiltersAnalytics';
import type { OffersFilterStoreState } from '../../store/types';
import { createApplyAndNotify } from './Filters/utils';
export function AppliedFilters() {
  const $ = _c(21);
  const {
    filterFormState,
    handleSingleFormUpdate,
    handleClearFilters,
    handleApplyFilters,
    selectedNonDefaultFilters
  } = useOffersFilterStore(useShallow(_temp));
  const {
    fireClearAllEvents,
    firePillsRemovalEvents
  } = useFiltersAnalytics();
  let t0;
  if ($[0] !== filterFormState || $[1] !== firePillsRemovalEvents || $[2] !== handleApplyFilters || $[3] !== handleSingleFormUpdate) {
    t0 = (type, value, label) => {
      const currentValue = filterFormState[type];
      const newValue = Array.isArray(currentValue) ? currentValue.filter(item => item !== value) : initialFilterState[type];
      createApplyAndNotify(handleSingleFormUpdate, handleApplyFilters)({
        type,
        value: newValue
      });
      firePillsRemovalEvents(label);
    };
    $[0] = filterFormState;
    $[1] = firePillsRemovalEvents;
    $[2] = handleApplyFilters;
    $[3] = handleSingleFormUpdate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleFilterRemoval = t0;
  let t1;
  if ($[5] !== fireClearAllEvents || $[6] !== handleApplyFilters || $[7] !== handleClearFilters) {
    t1 = () => {
      startTransition(() => {
        handleClearFilters();
        handleApplyFilters();
      });
      fireClearAllEvents();
    };
    $[5] = fireClearAllEvents;
    $[6] = handleApplyFilters;
    $[7] = handleClearFilters;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleClearAll = t1;
  if (selectedNonDefaultFilters.length === 0) {
    return null;
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      flexWrap: "wrap",
      minWidth: 0,
      gap: 2
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== handleFilterRemoval || $[11] !== selectedNonDefaultFilters) {
    let t4;
    if ($[13] !== handleFilterRemoval) {
      t4 = t5 => {
        const {
          type: type_0,
          label: label_0,
          value: value_0
        } = t5;
        return <Chip key={`${type_0}-${value_0}`} label={label_0} onClick={() => handleFilterRemoval(type_0, value_0, label_0)} showCloseIcon={true} />;
      };
      $[13] = handleFilterRemoval;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = selectedNonDefaultFilters.map(t4);
    $[10] = handleFilterRemoval;
    $[11] = selectedNonDefaultFilters;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[15] !== handleClearAll || $[16] !== selectedNonDefaultFilters.length) {
    t4 = selectedNonDefaultFilters.length > 1 && <Chip label="Clear all" onClick={handleClearAll} aria-label="Clear all filters" />;
    $[15] = handleClearAll;
    $[16] = selectedNonDefaultFilters.length;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t3 || $[19] !== t4) {
    t5 = <Stack direction="row" sx={t2}>{t3}{t4}</Stack>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}
function _temp(state) {
  return {
    filterFormState: state.filterFormState,
    handleSingleFormUpdate: state.handleSingleFormUpdate,
    handleClearFilters: state.handleClearFilters,
    handleApplyFilters: state.handleApplyFilters,
    selectedNonDefaultFilters: state.selectedNonDefaultFilters
  };
}